import { Avatar } from "@mui/material";
import { PersonaAvatar, PERSONAS } from "./PersonaAvatar";

// Persona accent colors (used only for the last-resort monogram for unknown ids).
const AGENT_COLOR: Record<string, string> = {
  orchestrator: "#00b886",
  agent_1_statement_retrieval: "#0091d6",
  agent_2_bank_import: "#ff9040",
  agent_3_qb_posting: "#2ca01c",
  agent_4_invoice_collector: "#b23cff",
  agent_5_matching: "#ff4466",
  agent_watchdog: "#7a869a",
  qb_drift_scanner: "#7a869a",
};

const AGENT_INITIALS: Record<string, string> = {
  agent_watchdog: "WD",
  qb_drift_scanner: "DS",
};

/**
 * Agent profile photo. Priority:
 *   1. a real photo at /agent-avatars/<agentId>.png (if present)
 *   2. inline persona art derived from the 3D Agent Office (PersonaAvatar)
 *   3. a colored monogram (only for ids without a persona, e.g. the watchdog)
 */
export function AgentAvatar({ agentId, size = 36 }: { agentId: string; size?: number }) {
  const persona = PERSONAS[agentId];
  const color = AGENT_COLOR[agentId] ?? "#7a869a";
  const initials = AGENT_INITIALS[agentId] ?? agentId.slice(0, 2).toUpperCase();

  return (
    <Avatar
      src={`/agent-avatars/${agentId}.png`}
      alt={agentId}
      sx={{ width: size, height: size, bgcolor: persona ? "transparent" : color, color: "#fff", fontSize: size * 0.4, fontWeight: 700 }}
    >
      {persona ? <PersonaAvatar agentId={agentId} size={size} /> : initials}
    </Avatar>
  );
}
